// ══════════════════════════════════════════════════════════════════════════════════════════════
//  B-270 · CUANDO NO QUEDA NI UNA PESTAÑA: DECIRLO, NO ENSEÑAR UNA PÁGINA EN BLANCO
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  Con un permiso por pestaña, hay un final del que no se puede escapar: que a alguien se le quiten
//  TODAS las de un módulo. Sin esto, esa persona se encontraría una barra vacía y una pantalla en
//  blanco, o —peor— un salto a su pantalla de inicio sin ningún motivo, y llamaría a soporte a
//  preguntar qué se ha roto.
//
//  La frase dice las tres cosas que hacen falta: QUÉ pasa, que NO es una avería, y A QUIÉN
//  pedírselo. Es el mismo camino que ya seguía Seguimiento cuando no le quedaba ninguna pestaña.
//
//  Sin emojis y con el nombre del módulo tal cual lo lee el usuario en el menú.
import { t, tx } from '../utils/i18n'   // B-2259 · los textos, en el idioma de quien mira (utils/i18n)

export default function SinPestanas({ modulo = t('components.SinPestanas.este_modulo', 'este módulo') }) {
  return (
    <div style={{ padding: 26, textAlign: 'center', color: 'var(--text-muted)', fontSize: 14, maxWidth: 520, margin: '0 auto' }}>
      <div style={{ fontWeight: 700, color: 'var(--text-secondary)', marginBottom: 6 }}>
        {tx('components.SinPestanas.no_tienes_ninguna_pestana_de', 'No tienes ninguna pestaña de {{modulo}}', { modulo })}
      </div>
      <div style={{ lineHeight: 1.5 }}>
        {t('components.SinPestanas.no_es_un_error_la', 'No es un error: la clínica te las ha quitado todas. Si necesitas alguna, pídesela a quien administre la clínica — se conceden en Ajustes → Usuarios, doctores y permisos.')}
      </div>
    </div>
  )
}
